import Quill from "quill";
import { ImageHandler, AttachmentHandler } from "quill-upload";

// register quill-upload
Quill.register("modules/imageHandler", ImageHandler);
Quill.register("modules/attachmentHandler", AttachmentHandler);

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;

const parseUploadResponse = (response) => {
  return response.json().catch(() => ({})).then((result) => {
    if (!response.ok || !result.url) {
      throw new Error(result.error || "アップロードに失敗しました。ページを再読み込みしてからお試しください。");
    }
    return result;
  });
};

window.createQuill = function(selector) {
  const fullToolbarOptions = [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['link'],
    ['image', 'attachment']
  ];

  const editor = new Quill(selector, {
    theme: 'snow',
    modules: {
      toolbar: {
        container: fullToolbarOptions,
      },
      imageHandler: {
        upload: (file) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            fetch(
              "/admin/quills/upload_image",
              {
                method: "POST",
                headers: { "X-CSRF-Token": csrfToken() },
                body: formData
              }
            )
            .then(parseUploadResponse)
            .then((result) => {
              resolve(result.url);
            })
            .catch((error) => {
              window.alert(error.message);
              reject("Upload failed");
              console.error("Error:", error);
            });
          });
        }
      },
      attachmentHandler: {
        upload: file => {
          // return a Promise that resolves in a link to the uploaded image
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", file);

            fetch(
              "/admin/quills/upload_file",
              {
                method: "POST",
                headers: { "X-CSRF-Token": csrfToken() },
                body: formData
              }
            )
            .then(parseUploadResponse)
            .then((result) => {
              resolve(result.url);
            })
            .catch((error) => {
              window.alert(error.message);
              reject("Upload failed");
              console.error("Error:", error);
            });
          })
        }
      },
    },
  });

  return editor;
}
